import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'vimeoEmbed' })
export class VimeoEmbedPipe implements PipeTransform {
  constructor() { }

  transform(url: any): string {
    if (!url) {
      return '';
    }
    const id = this.getVimeoID(url);
    if (!id) {
      return '';
    }
    const hashMatch = typeof url === 'string' ? url.match(/[?&]h=([a-zA-Z0-9]+)/i) : null;
    const hashQuery = hashMatch && hashMatch[1] ? `?h=${hashMatch[1]}` : '';
    return 'https://player.vimeo.com/video/' + id + hashQuery;
  }

  getVimeoID(url: string): string {
    if (!url) {
      return '';
    }
    if (typeof url !== 'string') {
      return '';
    }
    const cleanUrl = url.trim();
    if (/^\d+$/.test(cleanUrl)) {
      return cleanUrl;
    }
    // tslint:disable-next-line:max-line-length
    const regExp = /(?:https?:)?\/\/(?:www\.|player\.)?vimeo\.com\/(?:channels\/(?:\w+\/)?|groups\/([^\/]*)\/videos\/|album\/(\d+)\/video\/|video\/|)(\d+)/i;
    const match = cleanUrl.match(regExp);
    return (match && match[3]) ? match[3] : '';
  }

}

